<app-content-header role="banner" text="Upcoming Bookings"></app-content-header>
<app-bookings-tile
  *ngFor="let booking of this.bookingService.bookingList"
  [booking]="booking"
  ></app-bookings-tile>
<span
  *ngIf="(this.bookingService.bookingList)?.length === 0"
  class="lato"
>No records found.</span>
